import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import DayPicker, { DateUtils } from 'react-day-picker'

const AddRoundsManually = ({
  details,
  setDetails,
  dayRoundNumber,
  setDayRoundNumber,
  numberOfExistingRounds,
}) => {
  const [monthChanged, setMonthChanged] = useState(false)

  useEffect(() => {
    computeDayRoundsCount()
  }, [])

  useEffect(() => {
    if (monthChanged === true) {
      computeDayRoundsCount()
    }
    setMonthChanged(false)
  }, [monthChanged])

  const computeDayRoundsCount = () => {
    const newDates = {}
    details.rounds.forEach(round => {
      const key = String(moment(round).format('ddd MMM DD YYYY'))
      newDates[key] = (newDates[key] || 0) + 1
    })
    setDayRoundNumber(newDates)

    Object.entries(newDates).forEach(([key, count]) => {
      const elements = document.querySelectorAll(`div[aria-label="${key}"]`)
      // check if the day is displayed in both month calendars
      // (first / last days in previous / next month are grayed out to complete the calendar)
      // and we have to add the multiple class to both
      if (elements.length === 2) {
        elements.forEach(e => {
          e.className = `${e.className} multiple--${count}`
        })
      } else if (elements[0]) {
        elements[0].className = `${elements[0].className} multiple--${count}`
      }
    })
  }

  const computeRoundsCount = (day) => {
    return details.rounds && details.rounds.filter(selectedDay =>
      DateUtils.isSameDay(selectedDay, day)
    ).length
  }

  const handleDayClick = (day, { disabled }, event) => {
    if (!disabled && !moment(day).isBefore(moment(), 'day')) {
      let newDates = { ...dayRoundNumber, [String(moment(day).format('ddd MMM DD YYYY'))]: computeRoundsCount(day) + 1}
      setDayRoundNumber({ ...newDates } )
      setDetails({
        ...details,
        manuallyRounds: [ ...details.manuallyRounds, day ],
        rounds: [ ...details.rounds, day],
      })

      let className = ''
      Object.keys(newDates).forEach( key => {
        if (event.target.ariaLabel.includes(key) && event.target.ariaDisabled.includes(false) ) {
          className = ` multiple--${newDates[key]}`
          if (event.target.className.includes('selected'))
            event.target.className += className
        }
      })
    }
  }

  return (
    <div>
      <p className='content_information rounds_type_info'>
        { window.I18n.t('shared.components.schedule_rounds.add_rounds_manually_info') }
      </p>
      <DayPicker
        className='add_round_manually_picker'
        numberOfMonths={ 2 }
        selectedDays={ details.rounds }
        onDayClick={ (day, modifier, event) => handleDayClick(day, modifier, event) }
        fixedWeeks={ true }
        showOutsideDays={ true }
        mode='multiple'
        onMonthChange={ () => setMonthChanged(true) }
        disabledDays={
          numberOfExistingRounds && numberOfExistingRounds === details.rounds.length
            ? [ { before: new Date() }, { after: new Date() }, new Date() ]
            : { before: new Date() }
        }
      />
    </div>
  )
}

AddRoundsManually.propTypes = {
  details: PropTypes.object.isRequired,
  setDetails: PropTypes.func.isRequired,
  dayRoundNumber: PropTypes.object.isRequired,
  setDayRoundNumber: PropTypes.func.isRequired,
  numberOfExistingRounds: PropTypes.number.isRequired,
}

export default AddRoundsManually
